import axios from "axios";

// 임직원 MS 로그인(POST /auth/login/ms) 의 reject 를 화면 동작으로 변환 (VMD-399)
//  - 이미 성공한 호출이 있으면: 우리 쪽 /home 이동이 아직 날아가고 있던 형제 요청을
//    취소시킨 것이다. 아무것도 하지 않는다. 예전 코드는 여기서 알럿을 띄우고
//    location.href = "/" 를 실행해 성공한 로그인을 되돌렸고, 취소된 요청 수만큼
//    알럿이 반복됐다.
//  - 401: selectMsUser 가 해당 이메일로 ERP 행을 찾지 못한 경우
//  - status 없음: 요청이 완료되지 않았다(네트워크 또는 취소)
//  - 그 외: 상태코드를 문구에 함께 실어 다음 발생 때 바로 진단되게 한다
//    (예전에는 401 이 아닌 전부가 "서버 오류 발생" 한 줄이라 클라이언트 오류도
//     서버 장애로 읽혔다)
export type MsLoginErrorAction = { kind: "ignore"; reason: string } | { kind: "alert"; message: string };

export const MS_LOGIN_NO_ACCOUNT_MESSAGE = "일치하는 아이디가 없습니다";
export const MS_LOGIN_NETWORK_MESSAGE = "네트워크 문제로 로그인을 완료하지 못했습니다. 다시 시도해 주세요.";

// axios 가 던진 에러에서만 HTTP 상태를 읽는다. 취소된 요청과 TypeError 는 undefined
export const getMsLoginStatus = (error: unknown): number | undefined => (axios.isAxiosError(error) ? error.response?.status : undefined);

export const resolveMsLoginError = (error: unknown, alreadySucceeded: boolean): MsLoginErrorAction => {
  const status = getMsLoginStatus(error);
  if (alreadySucceeded) return { kind: "ignore", reason: `cancelled after a successful login (status=${status ?? "none"})` };
  if (status === 401) return { kind: "alert", message: MS_LOGIN_NO_ACCOUNT_MESSAGE };
  if (status === undefined) return { kind: "alert", message: MS_LOGIN_NETWORK_MESSAGE };
  return { kind: "alert", message: `서버 오류 발생 (${status})` };
};
